var React = require('react');

function TnplusLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.7368 9.28418H0V14.6764H11.6539V55.0481H17.0361V14.6764H28.7368V9.28418Z","fill":"white","key":0}),React.createElement("path",{"d":"M55.3211 9.28418V43.9822L35.9448 9.28418H30.5625V55.0481H35.9448V20.35L55.3211 55.0481H60.7502V9.28418H55.3211Z","fill":"white","key":1}),React.createElement("path",{"d":"M60 14.9108H72.2155L76.7085 0H81.5292V35.3076H76.9425V15.0514L75.3513 19.4121H60V14.9108Z","fill":"white","key":2}),React.createElement("path",{"d":"M98.4726 20.3968H86.2571L81.764 35.3076H76.9434V0H81.53V20.2561L83.1213 15.8954H101L98.4726 20.3968Z","fill":"white","key":3})]);
}

TnplusLogoInline.defaultProps = {"width":"101","height":"56","viewBox":"0 0 101 56","fill":"none"};

module.exports = TnplusLogoInline;

TnplusLogoInline.default = TnplusLogoInline;
